module.exports = __webpack_public_path__ + "static/img/old_classroom_tradition@2x.af6a2a53.png";